import { ReactElement } from 'react';
import { IBaseModel, IListFetchParams, useListContext } from '../../../common';
import { gridFieldsFormatRules } from '../../../utils';
import { cn } from '@jobcost-monorepo/utils';
import { Icon } from '@jobcost-monorepo/ui';
import React from 'react';
import { useTranslation } from '@jobcost-monorepo/i18n';

interface Props<T extends IBaseModel> {
  element: T;
  className?: string;
}

const CardRow = <T extends IBaseModel, Q extends IListFetchParams>({
  element,
  className,
}: Props<T>): ReactElement => {
  const { setFormElement, setFormOpen, setDeleteModalOpen, repository } =
    useListContext<T, Q>();
  const { t } = useTranslation(repository.moduleName?.toLocaleLowerCase());

  const handleEdit = () => {
    setFormElement(element);
    setFormOpen(true);
  };

  const handleDelete = () => {
    setFormElement(element);
    setDeleteModalOpen(true);
  };

  return (
    <div className={cn('w-full flex-col p-2', className)}>
      {repository.gridFieldsOptions
        .filter((col) => col.visible)
        .sort((col1, col2) => col1.position - col2.position)
        .map((col, index) => (
          <div key={`${String(col.linkedField)}${index}`}>
            <div className="flex flex-row overflow-hidden">
              <span className="line-clamp-1 font-bold mr-4">
                {t(`grid.${String(col.linkedField)}`)}
              </span>
              <span className="line-clamp-1">
                {gridFieldsFormatRules(
                  element,
                  col.linkedField,
                  col.formatType,
                  col.translationModuleName,
                  col.enumValues,
                )}
              </span>
            </div>
          </div>
        ))}

      <div className="flex flex-row cursor-pointer space-x-4 my-auto mt-2">
        <div onClick={handleEdit}>
          <Icon
            iconName="edit"
            className="hover:opacity-50 fill-black stroke-black dark:fill-white dark:stroke-white"
          />
        </div>

        <div onClick={handleDelete}>
          <Icon
            iconName="remove"
            className="fill-pink stroke-pink hover:opacity-50"
          />
        </div>
      </div>
    </div>
  );
};

export default CardRow;
